import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import fetchWrapper from '../utils/httpClient';

export const resetPassword = createAsyncThunk(
  'passwordReset/reset',
  async ({ email, baseUrlHost }) => {
    const url = `/cmsadmin/api/passwordReset?email=${email}&baseUrlHost=${baseUrlHost}`;
    try {
      const response = await fetchWrapper.post(url, {});
      return response;
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

export const validateTokenAndPassword = createAsyncThunk(
  'passwordReset/validateTokenAndPassword',
  async ({ email, token }) => {
    const url = `/cmsadmin/api/passwordReset/token-email/validation?email=${email}&token=${token}`;
    try {
      const response = await fetchWrapper.get(url, { email, token });
      return response;
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

export const changePassword = createAsyncThunk(
  'passwordReset/changePassword',
  async ({ confirmPassword, email, newPassword, token }) => {
    const url = `/cmsadmin/api/passwordReset/change-password`;
    try {
      const response = await fetchWrapper.post(url, { confirmPassword, email, newPassword, token });
      return response;
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const passwordResetSlice = createSlice({
  name: 'passwordReset',
  initialState: {
    loading: false,
    error: null,
    status: null
  },
  extraReducers: (builder) => {
    builder
      //show reset-password page
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = "pending";
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.status = "500";
      })

      //validateToken and emali
      .addCase(validateTokenAndPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = "pending";
      })
      .addCase(validateTokenAndPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.status = action.payload.status === '200' ? "200" : "500";
      })
      .addCase(validateTokenAndPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.status = "500";
      })

      //changePassword
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = "pending";
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "passwordChanged";
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.status = "400";
      });
  }
});

export default passwordResetSlice.reducer;    